import React from "react";
import { Menu, Container, Image } from "semantic-ui-react";

const HomeMenu = () => {
  return (
    <Menu fixed="top" secondary size="massive" className="navBarPrymera">
      <Container>
        <Menu.Item header>
          <Image src="/assets/images/logo-prymera.svg" size="small" centered />
        </Menu.Item>
      </Container>
    </Menu>
  );
};

export default HomeMenu;
